module.exports = __webpack_public_path__ + "6168680bb2310849d6c0278341fb06f9.png";